import { render, staticRenderFns } from "./FontSelect.vue?vue&type=template&id=f5efadb4"
import script from "./FontSelect.vue?vue&type=script&lang=js"
export * from "./FontSelect.vue?vue&type=script&lang=js"
import style0 from "./FontSelect.vue?vue&type=style&index=0&id=f5efadb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports